import { Router } from '@/Router';
import { Toaster } from '@/components/ui/toaster';
import { ErrorBoundary } from '@/components/ErrorBoundary';
import { useSingleTabLock } from '@/utils/singleTabLock';

function PassiveTabScreen() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-950 px-6 text-white">
      <div className="w-full max-w-sm rounded-lg border border-white/10 bg-white/5 p-6 text-center">
        <h1 className="mb-2 text-lg font-semibold">Player baska sekmede acik</h1>
        <p className="text-sm text-white/70">
          Bu cihaz icin aktif oynatma sekmesi zaten calisiyor. Calmayi bu sekmede baslatmak icin diger sekmeyi kapatin.
        </p>
      </div>
    </div>
  );
}

function App() {
  const { isActiveTab } = useSingleTabLock();

  return (
    <ErrorBoundary>
      {isActiveTab ? <Router /> : <PassiveTabScreen />}
      <Toaster />
    </ErrorBoundary>
  );
};

export default App;
